import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  CardRequest,
  CardResponse,
  UpdateCreditCardRequest,
  PaymentsHubRequest,
  GetCardsResponse,
} from '../models/card.model';

import { ApiService } from './api.service';
@Injectable({
  providedIn: 'root',
})
export class CreditCardService {
  private apiService = inject(ApiService);

  private readonly API_URL = '/card';

  addCard(payload: CardRequest): Observable<CardResponse> {
    return this.apiService.post<CardResponse>(this.API_URL, payload);
  }

  updateCreditCard(payload: UpdateCreditCardRequest): Observable<any> {
    return this.apiService.put(
      `${this.API_URL}/update-credit-card`,
      payload
    );
  }

  paymentsHub(payload: PaymentsHubRequest): Observable<any> {
    return this.apiService.post(`${this.API_URL}/payments-hub`, payload);
  }

  getCards(userUuid: string): Observable<GetCardsResponse> {
    return this.apiService.get(`${this.API_URL}/list-cards-by-user/${userUuid}`);
  }
}
